<div class="modal-body" style="height: auto">
    <div style="/*height: 400px*/">
        <div class="col-sm-12 header" style="padding: 0px">
            <h4 class="col-sm-10" style="padding:0px; margin: 0;">
                <span> {{ titre }} </span>
            </h4>
            <button type="button" class="close pull-right" aria-label="Close" style="margin: 0" (click)="annuler();">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="col-sm-12 tab" style="padding: 0px; height: calc(100% - 30px); margin-top: 20px">
            <div class="form-group col-sm-12" style="padding: 0;">
                <label class="col-sm-3 champ" for="input-file-id" style="padding: 0;"> Fichier (Max. 2Mo) : </label>
                <input class="hide" id="input-file-id" (change)="getNameFile($event, fileToAdd)" multiple type="file"  accept="{{ common.extFichierImg }}"  />
                       <div class="input-group col-sm-9 champ">
                    <input type="text" class="form-control" [(ngModel)]="fileToAdd.nomFichier" readonly>
                    <label class="input-group-addon" for="input-file-id"><i class="fa fa-upload"></i> Parcourir </label>
                </div>
            </div>            

            <div class="form-group col-sm-12" style="padding: 0;" *ngIf="cheminLogo">
                <label class="col-sm-3 champ" for="input-file-id" style="padding: 0;">&nbsp;</label>
                <div class="input-group col-sm-9 champ" >
                    <img src="{{ cheminLogo }}" alt="{{ cheminLogo }}" style="max-width: 100%; width: auto; max-height: 100px;"/>
                    <!--
                    <button class="btn-header uppercase" id="supprimer" (click)="deleteLogo()" style="margin-left: 10px">
                        Supprimer </button>                  
                    -->
                </div>
            </div>          
        </div>
    </div>
    <div class="text-right col-sm-12" style="padding: 0px; padding-bottom: 5px;">
        <button type="button" class=" btn-close btn-valider" (click)="save()"> Valider </button>
        <button type="button" class=" btn-close  btn-simple" (click)="annuler()" style="margin-left: 5px;"> Annuler
        </button>
    </div>
</div>

  <ng-template #msg>
    <div class="modal-body" style="height: auto">
        <div>
            <div class="col-sm-12">
                <label class="cofirmemsg" [innerHTML]="error"> </label>
            </div>
        </div>
        <div class="text-right" style="margin-top: 15px;">
            <button type="button" class=" btn-close btn-valider" (click)="error = ''; common.closeModal()"> Fermer </button>
        </div>
    </div>
  </ng-template>